
export const LinkHandler = (navigate,path,id) => {
 return  navigate(`/${path}/${id}`);
}